import {createQuerySuggestionsPlugin, getTemplates} from '@algolia/autocomplete-plugin-query-suggestions';

export function getQuerySuggestionsPlugin(searchClient, translations) {
    return createQuerySuggestionsPlugin({
        searchClient,
        indexName: ACC.config.algolia.index + '_query_suggestions',
        getSearchParams({ state }) {
            return { hitsPerPage: ACC.config.algolia.autocompleteQuerySuggestionsMax };
        },
        transformSource({source}) {
            return {
                ...source,
                templates: {
                    ...source.templates,
                    header() {
                        return translations['algolia.search.autocomplete.header.querysuggestion'];
                    },
                    footer() {
                        return '';
                    },
                },
                onSelect({setQuery, state}) {
                    setQuery(state.query);
                    $('.aa-SubmitButton').click();
                },
            };
        },
    });
}